import { CursorPaginatedResponseSchema, DefaultCursorPageSchema, isDefined } from 'notable-common';
import { z } from 'zod';
/** No `sort`: results come back latest start time first. */
export const EncounterListQuerySchema = z
    .object({
    ehrInformationId: z.uuid().optional().describe("Return only this patient record's encounters."),
    // An empty array would serialize to no parameter at all, and so ask for every encounter.
    ids: z
        .union([z.uuid(), z.array(z.uuid()).min(1).max(100)])
        .optional()
        .describe('Return only these encounters, such as the id in a staff encounter link.'),
    ehrReferenceValue: z
        .string()
        .min(1)
        .max(100)
        .optional()
        .describe('Return only encounters with exactly this EHR encounter number (FIN).'),
    ehrAppointmentReferenceValue: z
        .string()
        .min(1)
        .max(100)
        .optional()
        .describe('Return only encounters with exactly this EHR appointment id (APPT_ID).'),
    startTimeAfter: z.iso
        .datetime({ offset: true })
        .optional()
        .describe('Return only encounters starting at or after this instant.'),
    startTimeBefore: z.iso
        .datetime({ offset: true })
        .optional()
        .describe('Return only encounters starting before this instant.'),
    includeDeleted: z
        .enum(['true', 'false'])
        .transform((value) => value === 'true')
        .optional()
        .describe('Include encounters that have been deleted.'),
    page: DefaultCursorPageSchema,
})
    .strict()
    .refine((query) => isDefined(query.ehrInformationId) ||
    isDefined(query.ids) ||
    isDefined(query.ehrReferenceValue) ||
    isDefined(query.ehrAppointmentReferenceValue), {
    message: 'ehrInformationId, ids, ehrReferenceValue, or ehrAppointmentReferenceValue is required',
});
export const EncounterListEntrySchema = z.object({
    id: z.uuid(),
    ehrInformationId: z.uuid(),
    practiceId: z.uuid(),
    startTime: z.iso.datetime(),
    endTime: z.iso.datetime().nullable(),
    ehrReferenceValue: z.string().nullable().describe('The EHR encounter number (FIN).'),
    ehrAppointmentReferenceValue: z.string().nullable().describe('The EHR appointment id (APPT_ID).'),
    appointmentStatus: z
        .string()
        .nullable()
        .describe('Current appointment status, such as RESCHEDULED.'),
    kindOfVisit: z.string().nullable().describe("The EHR's visit reason."),
    deleted: z.boolean(),
    deletedTimestamp: z.iso.datetime().nullable(),
    deletedReason: z
        .string()
        .nullable()
        .describe('Why it was deleted, such as ENCOUNTER_CANCELED_IN_EHR.'),
    created: z.iso.datetime(),
    updated: z.iso.datetime(),
});
export const EncounterListResponseSchema = CursorPaginatedResponseSchema(EncounterListEntrySchema);
//# sourceMappingURL=list.js.map